var _require = require("./src/Store"),
    Store = _require.Store;

var Reducers = require("./src/Reducers");

var _require2 = require("./src/ActionCreator"),
    ActionCreator = _require2.ActionCreator;

module.exports = {
  createStore: function createStore() {
    return new Store(Reducers.Reducer);
  },
  ActionCreator: ActionCreator,
  Reducers: Reducers
};